import { useState, useEffect } from "react";
import { jwtFetch } from "./utils/apiClient";
import { format, subMonths } from "date-fns";
import { config, priceFormat } from "./Components/Config";
import Select from "react-select";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const Report = () => {
  const [rawLeads, setRawLeads] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [filterCreatedDateStart, setFilterCreatedDateStart] = useState(format(subMonths(new Date(), 1), 'yyyy-MM-dd'));
  const [filterCreatedDateEnd, setFilterCreatedDateEnd] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [filterCategory, setFilterCategory] = useState([]);
  const [filterSourceChannel, setFilterSourceChannel] = useState([]);
  const [filterSourceName, setFilterSourceName] = useState([]);
  const [filterSalesName, setFilterSalesName] = useState([]);
  const [isGenerated, setIsGenerated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  const leadCategoryOptions = [
    { value: 'Google Cloud', label: 'Google Cloud' },
    { value: 'Google Workspace', label: 'Google Workspace' },
    { value: 'AppSheet', label: 'AppSheet' },
    { value: 'O365', label: 'O365' },
    { value: 'NetSuite', label: 'NetSuite' },
    { value: 'Cisco Meraki', label: 'Cisco Meraki' },
    { value: 'Education', label: 'Education' },
    { value: 'Conferencing Solutions', label: 'Conferencing Solutions' },
    { value: 'Logitech', label: 'Logitech' },
    { value: 'Hardware', label: 'Hardware' },
    { value: 'CM/Training', label: 'CM/Training' },
    { value: 'Services', label: 'Services' },
    { value: 'Lumapps', label: 'Lumapps' },
    { value: 'Project Management', label: 'Project Management' },
    { value: 'Samsung Flip 2', label: 'Samsung Flip 2' },
    { value: 'Workato', label: 'Workato' },
    { value: 'Others', label: 'Others' },
  ];

  const sourceNameOptions = [
    { value: 'Website', label: 'Website' },
    { value: 'Email', label: 'Email' },
    { value: 'Chat', label: 'Chat' },
    { value: 'Call', label: 'Call' },
    { value: 'Event', label: 'Event' },
    { value: 'Facebook', label: 'Facebook' },
    { value: 'LinkedIn', label: 'LinkedIn' },
    { value: 'Instagram', label: 'Instagram' },
    { value: 'Referral', label: 'Referral' },
    { value: 'WhatsApp', label: 'WhatsApp' },
  ];

  const sourceChannelOptions = [
    { value: 'Organic', label: 'Organic' },
    { value: 'Paid Search', label: 'Paid Search' },
  ];

  const sourceStatusOptions = [
    { value: 'Email Bounce', label: 'Email Bounce' },
    { value: 'Email Sent', label: 'Email Sent' },
    { value: 'Existing', label: 'Existing' },
    { value: 'WhatsApp Sent', label: 'WhatsApp Sent' },
  ];

  useEffect(() => {
    getLeads();
  }, []);

  const getLeads = async () => {
    try {
      setIsLoading(true);
      const requestLeads = {};
      const fetchLeads = await jwtFetch(config.ENDPOINT + 'get/lead', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestLeads)
      });
      const responseGetLeads = await fetchLeads.json();
      if (responseGetLeads.status === 200) {
        for (let l in responseGetLeads.data) {
          if (responseGetLeads.data[l].website_form) {
            responseGetLeads.data[l].website_form = JSON.parse(responseGetLeads.data[l].website_form);
          }
        }
        setRawLeads(responseGetLeads.data);
        setIsLoading(false);
      } else {
        alert(responseGetLeads.message);
      }
    } catch (error) {
      console.error('Error in getLeads:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoading(false);
    }
  };

  const generateReport = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    let filteredData = [...rawLeads];
    if (filterCreatedDateStart) {
      filteredData = filteredData.filter(q => new Date(q.created_on) >= new Date(filterCreatedDateStart));
    }
    if (filterCreatedDateEnd) {
      filteredData = filteredData.filter(q => new Date(q.created_on) <= new Date(filterCreatedDateEnd));
    }
    if (filterCategory.length > 0) {
      const categoryValues = filterCategory.map(s => s.value);
      filteredData = filteredData.filter(q => categoryValues.includes(q.lead_category));
    }
    if (filterSourceName.length > 0) {
      const sourceNameValues = filterSourceName.map(s => s.value);
      filteredData = filteredData.filter(q => sourceNameValues.includes(q.source_name));
    }
    if (filterSourceChannel.length > 0) {
      const sourceChannelValues = filterSourceChannel.map(s => s.value);
      filteredData = filteredData.filter(q => sourceChannelValues.includes(q.source_channel));
    }
    if (filterSalesName.length > 0) {
      const salesNameValues = filterSalesName.map(s => s.value);
      filteredData = filteredData.filter(q => salesNameValues.includes(q.lead_assigned_to));
    }
    console.log(filteredData);
    setTableData(filteredData);
    setIsGenerated(true);
    setIsLoading(false);
  }

  return (
    <div id="lead-report">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="lead" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                <section className={"mb-4 " + (isGenerated ? 'd-none' : '')}>
                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <div className="fs-24">Generate Lead Report</div>
                  </div>
                  <div className="row mb-4">
                    <div className="col-md-8">
                      <form className="bg-white border-radius-4 p-4" onSubmit={(e) => generateReport(e)}>
                        <div className="border border-1 border-radius-3 p-4 mb-3">
                          <div className="row form-group align-items-center mb-2">
                            <div className="col-md-4">
                              <label>Created Date</label>
                            </div>
                            <div className="col-md-4">
                              <input className="form-control" type="date" value={filterCreatedDateStart} onChange={(e) => setFilterCreatedDateStart(e.target.value)} required/>
                            </div>
                            <div className="col-md-4">
                              <input className="form-control" type="date" value={filterCreatedDateEnd} onChange={(e) => setFilterCreatedDateEnd(e.target.value)} required/>
                            </div>
                          </div>
                          <div className="row form-group align-items-center mb-2">
                            <div className="col-md-4">
                              <label>Category</label>
                            </div>
                            <div className="col-md-8">
                              <Select options={leadCategoryOptions} value={filterCategory} onChange={(e) => setFilterCategory(e)} isMulti/>
                            </div>
                          </div>
                          <div className="row form-group align-items-center mb-2">
                            <div className="col-md-4">
                              <label>Source</label>
                            </div>
                            <div className="col-md-8">
                              <Select options={sourceNameOptions} value={filterSourceName} onChange={(e) => setFilterSourceName(e)} isMulti/>
                            </div>
                          </div>
                          <div className="row form-group align-items-center mb-2">
                            <div className="col-md-4">
                              <label>Channel</label>
                            </div>
                            <div className="col-md-8">
                              <Select options={sourceChannelOptions} value={filterSourceChannel} onChange={(e) => setFilterSourceChannel(e)} isMulti/>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end">
                          <button className="btn bg-gold ms-2" type="submit" disabled={!setTableData.length || isLoading}>{!setTableData.length || isLoading ? 'Loading...' : 'Generate'}</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </section>

                <section className={isGenerated ? '' : 'd-none'}>
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center justify-content-between gap-4">
                      <div className="fs-24"><button className="btn btn-link" onClick={() => setIsGenerated(false)}><i className="bi bi-arrow-left"/></button> Report</div>
                    </div>
                    {/* <div className="d-flex align-items-center justify-content-between gap-2">
                      <button className="btn btn-link bg-gold" type="button" onClick={() => setPromptModal(true)}><i className="bi bi-stars me-1" disabled={isLoading}/> Ask Gemini</button>
                      <button className="btn btn-link bg-gold" type="button" onClick={() => generateXls()}><i className="bi bi-download me-1" disabled={isLoading}/> Export</button>
                    </div> */}
                  </div>
                  <div className="bg-white border-radius-4 p-4">
                    {/* <div className="border border-1 border-radius-3 p-4 mb-3">
                      <div id="printable-summary" style={{ maxHeight: isSummaryExpanded ? 'none' : '200px', overflow: 'hidden', position: 'relative' }}>
                        <div className="fs-18 mb-3">Report Summary</div>
                        {summaryLoading ? 'Loading...' : (
                          <div className="mb-3" dangerouslySetInnerHTML={{ __html: summaryResponse.replace(/```html/g, '').replace(/```/g, '') }} />
                        )}
                      </div>
                      {summaryResponse && (
                        <div className="d-flex gap-2 mt-3">
                          <button className="btn btn-outline-secondary" onClick={toggleSummaryExpansion}>{isSummaryExpanded ? 'See Less' : 'See More'}</button>
                          <button className="btn btn-link bg-gold" type="button" onClick={() => printSummary()}>Export</button>
                          <button className="btn btn-link bg-gold" type="button" onClick={() => setPromptModal(true)}><i className="bi bi-stars me-1" disabled={isLoading}/> Ask for More Details</button>
                        </div>
                      )}
                    </div> */}
                    <div className="table-responsive mb-2" style={{ maxHeight: 'calc(100vh - 230px)', overflow: 'auto' }}>
                      {isLoading ? (
                        <p>{isLoading ? 'Loading...' : 'No data'}</p>
                      ) : (
                        <table id="table-data" className="table table-hover mb-0" style={{ tableLayout: 'auto', width: '100%' }}>
                          <thead style={{ position: 'sticky', top: 0, zIndex: 3 }}>
                            <tr>
                              <th className="bg-gold w-40 text-nowrap">#</th>
                              <th className="bg-gold text-nowrap">Number</th>
                              <th className="bg-gold text-nowrap">Created Date</th>
                              <th className="bg-gold text-nowrap">Status</th>
                              <th className="bg-gold text-nowrap">Company Group</th>
                              <th className="bg-gold text-nowrap">Subsidiary</th>
                              <th className="bg-gold text-nowrap">Category</th>
                              <th className="bg-gold text-nowrap">Products</th>
                              <th className="bg-gold text-nowrap">Source</th>
                              <th className="bg-gold text-nowrap">Channel</th>
                              {/* <th className="bg-gold text-nowrap">SKUs</th>
                              <th className="bg-gold text-nowrap">Product Type</th>
                              <th className="bg-gold text-nowrap">Order Type</th>
                              <th className="bg-gold text-nowrap">Cost Price</th>
                              <th className="bg-gold text-nowrap">Selling Price</th>
                              <th className="bg-gold text-nowrap">Quantity</th>
                              <th className="bg-gold text-nowrap">Contract Month</th>
                              <th className="bg-gold text-nowrap">SKU Subtotal</th>
                              <th className="bg-gold text-nowrap">SKU Discount Amount</th>
                              <th className="bg-gold text-nowrap">SKU Discount %</th>
                              <th className="bg-gold text-nowrap">SKU Total Before Tax</th>
                              <th className="bg-gold text-nowrap">SKU Margin Amount</th>
                              <th className="bg-gold text-nowrap">SKU Margin %</th>
                              <th className="bg-gold text-nowrap">QT Subtotal</th>
                              <th className="bg-gold text-nowrap">QT Discount Amount</th>
                              <th className="bg-gold text-nowrap">QT Discount %</th>
                              <th className="bg-gold text-nowrap">QT Total Before Tax</th>
                              <th className="bg-gold text-nowrap">QT Margin Amount</th>
                              <th className="bg-gold text-nowrap">QT Margin %</th>
                              <th className="bg-gold text-nowrap">Payment Type</th>
                              <th className="bg-gold text-nowrap">Installment Type</th>
                              <th className="bg-gold text-nowrap">Total Schedules</th>
                              <th className="bg-gold text-nowrap">Period Start Date</th>
                              <th className="bg-gold text-nowrap">Period End Date</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {tableData.map((rowData, r) => 
                              <tr key={"data-" + r}>
                                <td className="w-40 text-nowrap" valign="top">{r + 1}</td>
                                <td className="text-nowrap" valign="top"><a href={"/lead/detail/" + rowData.id_lead} target="_blank" rel="noreferrer">{rowData.lead_code}</a></td>
                                <td className="text-nowrap" valign="top">{format(rowData.created_on, 'd MMM yyyy')}</td>
                                <td className="text-nowrap" valign="top">{rowData.lead_status}</td>
                                <td className="text-nowrap" valign="top">{rowData.company_name ? rowData.company_name : (rowData.website_form ? rowData.website_form.company_name : '')}</td>
                                <td className="text-nowrap" valign="top">{rowData.subcompany_name}</td>
                                <td className="text-nowrap" valign="top">{rowData.lead_category}</td>
                                <td className="text-nowrap" valign="top">{rowData.lead_products}</td>
                                <td className="text-nowrap" valign="top">{rowData.source_name}</td>
                                <td className="text-nowrap" valign="top">{rowData.source_channel}</td>
                                {/* <td className="text-nowrap" valign="top">{rowData.marketing_name}</td>
                                <td className="text-nowrap" valign="top">
                                  <ol className="mb-0">
                                    {rowData.quotation_items.map((item, i) => (
                                      <li key={i}>{item.product_name}</li>
                                    ))}
                                  </ol>
                                </td>
                                <td className="text-nowrap" valign="top">
                                  <ul className="list-unstyled mb-0">
                                    {rowData.quotation_items.map((item, i) => (
                                      <li key={i}>{item.product_type}</li>
                                    ))}
                                  </ul>
                                </td>
                                <td className="text-nowrap" valign="top">
                                  <ul className="list-unstyled mb-0">
                                    {rowData.quotation_items.map((item, i) => (
                                      <li key={i}>{item.service_type}</li>
                                    ))}
                                  </ul>
                                </td>
                                <td className="text-nowrap" valign="top" align="right">
                                  <ul className="list-unstyled mb-0">
                                    {rowData.quotation_items.map((item, i) => (
                                      <li key={i}>{priceFormat(item.product_cost_original, item.product_currency_original)}</li>
                                    ))}
                                  </ul>
                                </td>
                                <td className="text-nowrap" valign="top" align="right">
                                  <ul className="list-unstyled mb-0">
                                    {rowData.quotation_items.map((item, i) => (
                                      <li key={i}>{priceFormat(item.product_price_original, item.product_currency_original)}</li>
                                    ))}
                                  </ul>
                                </td>
                                <td className="text-nowrap" valign="top" align="right">
                                  <ul className="list-unstyled mb-0">
                                    {rowData.quotation_items.map((item, i) => (
                                      <li key={i}>{priceFormat(item.product_qty)}</li>
                                    ))}
                                  </ul>
                                </td>
                                <td className="text-nowrap" valign="top" align="right">
                                  <ul className="list-unstyled mb-0">
                                    {rowData.quotation_items.map((item, i) => (
                                      <li key={i}>{item.contract_long_period}</li>
                                    ))}
                                  </ul>
                                </td>
                                <td className="text-nowrap" valign="top" align="right">
                                  <ul className="list-unstyled mb-0">
                                    {rowData.quotation_items.map((item, i) => (
                                      <li key={i}>{priceFormat(item.product_subtotal, item.product_currency)}</li>
                                    ))}
                                  </ul>
                                </td>
                                <td className="text-nowrap" valign="top" align="right">
                                  <ul className="list-unstyled mb-0">
                                    {rowData.quotation_items.map((item, i) => (
                                      <li key={i}>{priceFormat(item.product_discount_price, item.product_currency)}</li>
                                    ))}
                                  </ul>
                                </td>
                                <td className="text-nowrap" valign="top" align="right">
                                  <ul className="list-unstyled mb-0">
                                    {rowData.quotation_items.map((item, i) => (
                                      <li key={i}>{priceFormat(item.product_discount_rate) + '%'}</li>
                                    ))}
                                  </ul>
                                </td>
                                <td className="text-nowrap" valign="top" align="right">
                                  <ul className="list-unstyled mb-0">
                                    {rowData.quotation_items.map((item, i) => (
                                      <li key={i}><strong>{priceFormat(item.product_total, item.product_currency)}</strong></li>
                                    ))}
                                  </ul>
                                </td>
                                <td className="text-nowrap" valign="top" align="right">
                                  <ul className="list-unstyled mb-0">
                                    {rowData.quotation_items.map((item, i) => (
                                      <li key={i}>{priceFormat(item.product_margin_price, item.product_currency)}</li>
                                    ))}
                                  </ul>
                                </td>
                                <td className="text-nowrap" valign="top" align="right">
                                  <ul className="list-unstyled mb-0">
                                    {rowData.quotation_items.map((item, i) => (
                                      <li key={i}>{priceFormat(item.product_margin_rate) + '%'}</li>
                                    ))}
                                  </ul>
                                </td>
                                <td className="text-nowrap" valign="top" align="right">{priceFormat(rowData.quotation_subtotal, rowData.quotation_currency)}</td>
                                <td className="text-nowrap" valign="top" align="right">{priceFormat(rowData.quotation_discount_price, rowData.quotation_currency)}</td>
                                <td className="text-nowrap" valign="top" align="right">{priceFormat(rowData.quotation_discount_rate) + '%'}</td>
                                <td className="text-nowrap" valign="top" align="right"><strong>{priceFormat(rowData.quotation_total, rowData.quotation_currency)}</strong></td>
                                <td className="text-nowrap" valign="top" align="right">{priceFormat(rowData.quotation_margin_price, rowData.quotation_currency)}</td>
                                <td className="text-nowrap" valign="top" align="right">{priceFormat(rowData.quotation_margin_rate) + '%'}</td>
                                <td className="text-nowrap" valign="top">{rowData.quotation_items[0].billing_payment_term}</td>
                                <td className="text-nowrap" valign="top">{rowData.quotation_items[0].billing_payment_period}</td>
                                <td className="text-nowrap" valign="top" align="right">{rowData.quotation_payments[0] && rowData.quotation_payments[rowData.quotation_payments.length - 1].term_number.replace('Term ', '')}</td>
                                <td className="text-nowrap" valign="top">{rowData.quotation_payments[0] && format(rowData.quotation_payments[0].start_term_period, 'd MMM yyy')}</td>
                                <td className="text-nowrap" valign="top">{rowData.quotation_payments[0] && format(rowData.quotation_payments[rowData.quotation_payments.length - 1].end_term_period, 'd MMM yyy')}</td> */}
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                </section>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Report;


